import {
    PlatformNavbar,
    PlatformNavbarMode
} from "@flexinet/ui-components";
import {getMenuItems} from "../data/menus.tsx";
import {useAllowedActions} from '../../../hooks/useAllowedActions.ts';
import product from '../../../config/product.ts';

export const PortalNavbar = (
    {
        mode,
        changeMode
    }: {
        mode: PlatformNavbarMode,
        changeMode: (mode: PlatformNavbarMode) => void
    }) => {

    const {allowedActions} = useAllowedActions()

    const items = getMenuItems()

    const menuItems = items.filter((item) => allowedActions.includes(item.rbac));


    return <PlatformNavbar
        appTitle={product.displayName}
        menuItems={menuItems}
        mode={mode}
        changeMode={changeMode}

    />

};
